// extracted by mini-css-extract-plugin
module.exports = {"Host":"MartyAnimation_Host__WmtNR","HostReady":"MartyAnimation_HostReady__UM5zl"};